// Alabama county FIPS codes (3-digit, zero-padded) → county name.
export const AL_COUNTY_NAMES = {
  '001': 'Autauga', '003': 'Baldwin', '005': 'Barbour', '007': 'Bibb',
  '009': 'Blount', '011': 'Bullock', '013': 'Butler', '015': 'Calhoun',
  '017': 'Chambers', '019': 'Cherokee', '021': 'Chilton', '023': 'Choctaw',
  '025': 'Clarke', '027': 'Clay', '029': 'Cleburne', '031': 'Coffee',
  '033': 'Colbert', '035': 'Conecuh', '037': 'Coosa', '039': 'Covington',
  '041': 'Crenshaw', '043': 'Cullman', '045': 'Dale', '047': 'Dallas',
  '049': 'DeKalb', '051': 'Elmore', '053': 'Escambia', '055': 'Etowah',
  '057': 'Fayette', '059': 'Franklin', '061': 'Geneva', '063': 'Greene',
  '065': 'Hale', '067': 'Henry', '069': 'Houston', '071': 'Jackson',
  '073': 'Jefferson', '075': 'Lamar', '077': 'Lauderdale', '079': 'Lawrence',
  '081': 'Lee', '083': 'Limestone', '085': 'Lowndes', '087': 'Macon',
  '089': 'Madison', '091': 'Marengo', '093': 'Marion', '095': 'Marshall',
  '097': 'Mobile', '099': 'Monroe', '101': 'Montgomery', '103': 'Morgan',
  '105': 'Perry', '107': 'Pickens', '109': 'Pike', '111': 'Randolph',
  '113': 'Russell', '115': 'St. Clair', '117': 'Shelby', '119': 'Sumter',
  '121': 'Talladega', '123': 'Tallapoosa', '125': 'Tuscaloosa', '127': 'Walker',
  '129': 'Washington', '131': 'Wilcox', '133': 'Winston',
};

/** Reverse lookup: lowercase county name → FIPS code. */
export const AL_COUNTY_FIPS_BY_NAME = Object.fromEntries(
  Object.entries(AL_COUNTY_NAMES).map(([fips, name]) => [name.toLowerCase(), fips]),
);

/** ALDOT's 5 administrative regions by county FIPS. Source: ALDOT District
 *  Contacts region maps (verified 2026-07-19). Regions are county-defined;
 *  measures do NOT reset at region lines in Alabama (display-only info). */
export const AL_COUNTY_REGION = {
  // North (13)
  '033': 'North', '019': 'North', '043': 'North', '049': 'North',
  '055': 'North', '059': 'North', '071': 'North', '077': 'North',
  '079': 'North', '083': 'North', '089': 'North', '095': 'North',
  '103': 'North',
  // East Central (12)
  '009': 'East Central', '015': 'East Central', '017': 'East Central',
  '027': 'East Central', '029': 'East Central', '037': 'East Central',
  '073': 'East Central', '111': 'East Central', '117': 'East Central',
  '115': 'East Central', '121': 'East Central', '123': 'East Central',
  // West Central (13)
  '007': 'West Central', '021': 'West Central', '057': 'West Central',
  '063': 'West Central', '065': 'West Central', '075': 'West Central',
  '093': 'West Central', '105': 'West Central', '107': 'West Central',
  '119': 'West Central', '125': 'West Central', '127': 'West Central',
  '133': 'West Central',
  // Southeast (19)
  '001': 'Southeast', '005': 'Southeast', '011': 'Southeast',
  '013': 'Southeast', '031': 'Southeast', '039': 'Southeast',
  '041': 'Southeast', '045': 'Southeast', '047': 'Southeast',
  '051': 'Southeast', '061': 'Southeast', '067': 'Southeast',
  '069': 'Southeast', '081': 'Southeast', '085': 'Southeast',
  '087': 'Southeast', '101': 'Southeast', '109': 'Southeast',
  '113': 'Southeast',
  // Southwest (10)
  '003': 'Southwest', '023': 'Southwest', '025': 'Southwest',
  '035': 'Southwest', '053': 'Southwest', '091': 'Southwest',
  '097': 'Southwest', '099': 'Southwest', '129': 'Southwest',
  '131': 'Southwest',
};
